import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import styles from 'features/chatAssist/components/chatAssist.module.scss';
import { msgInfo } from 'features/chatAssist/components/constants';

const MessagesContainerV3 = ({ messages, firstQuestionRef, firstResponseRef }) => {
  return messages.map((msg, index) => {
    const isFirstQuestion = index === 0 && msg.type === msgInfo.sender;
    const isFirstResponse = index === 0 && msg.type === msgInfo.recipient;

    return (
      <div
        key={index}
        ref={isFirstQuestion ? firstQuestionRef : isFirstResponse ? firstResponseRef : null}
        className={msg.type === msgInfo?.recipient ? styles.messageIA : styles.messageUser}
      >
        {msgInfo?.recipient === msg.type ? (
          <div className={styles.containerMarkDown}>
            <Markdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
              components={{
                a: ({ node, ...props }) => (
                  <a {...props} target="_blank" rel="noopener noreferrer">
                    {props.children}
                  </a>
                ),
              }}
            >
              {msg.message}
            </Markdown>
          </div>
        ) : (
          msg.message
        )}
      </div>
    );
  });
};

export default MessagesContainerV3;
